export default "__VITE_ASSET__R1ZHe1g5__"